import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { accountService, alertService } from '../_services';

function ResetPassword({ history }) {

    const { t } = useTranslation();

    const initialValues = {
        password: '',
        confirmPassword: ''
    };

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .min(6, t("PasswordAtLeast6Chars"))
            .required(t("passwordIsRequired")),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], t("PasswordsMustMatch"))
            .required(t("confirmPasswordRequired")),
    });

    function onSubmit({ password, confirmPassword }, { setSubmitting }) {
        alertService.clear();
        setSubmitting(true);
        accountService.resetPassword(password)
            .then(() => {
                setSubmitting(false);
                alertService.success(t("PasswordResetSuccess"), { keepAfterRouteChange: true });
                history.push('login');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }


    return (
        <div>
            <h3 className="card-header">{t("UpdatePassword")} </h3>
            <div className="card-body">
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                    {({ errors, touched, isSubmitting }) => (
                        <Form>
                            <div className="form-group">
                                <label>{t("Password")} </label>
                                <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label>{t("confirmPassword")} </label>
                                <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                                <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-row">
                                <div className="form-group col">
                                    <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                       {t("UpdatePassword")}
                                    </button>
                                    {/* <Link to="login" className="btn btn-link">{t("Cancel")} </Link> */}
                                    <Link to="." className="btn btn-link">{t("Cancel")}</Link>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>

            </div>
        </div>
    )
}

export { ResetPassword }; 